import type { PropsWithChildren } from "react";

import { Popover } from "antd";
import { useAtom } from "jotai";

import { NotificationsTabs } from "@/modules/notifications/notifications-tabs";

import { notificationsPanelOpenAtom } from "./notifications-panel.state";

import "./notifications-panel.style.less";

export const NotificationsPanel = ({ children }: PropsWithChildren) => {
  const [open, setOpen] = useAtom(notificationsPanelOpenAtom);

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
      arrow={false}
      placement="bottomRight"
      align={{ offset: [0, 9] }}
      getPopupContainer={() => document.body}
      destroyOnHidden
      classNames={{ root: "notifications-panel-overlay" }}
      content={
        <div className="notifications-panel-content">
          <NotificationsTabs />
        </div>
      }
    >
      <div className="notifications-panel-trigger">{children}</div>
    </Popover>
  );
};
